import { IVideoCategoriesContext, IFilterValues } from './videoCategoriesContext';

export enum VideoCategoriesActionTypes {
	SET_VIDEO_CATEGORIES = 'SET_VIDEO_CATEGORIES',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface ISetVideoCategories {
	type: VideoCategoriesActionTypes.SET_VIDEO_CATEGORIES;
	payload: {
		videoCategories: IVideoCategoriesContext['videoCategories'];
		typeOfModalWindow: IVideoCategoriesContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: VideoCategoriesActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IVideoCategoriesContext['searchString'];
	};
}

interface IResetSelectedControls {
	type: VideoCategoriesActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: VideoCategoriesActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IVideoCategoriesContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: VideoCategoriesActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IVideoCategoriesContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: VideoCategoriesActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IVideoCategoriesContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: VideoCategoriesActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IVideoCategoriesContext['IDForDeletion'];
		typeOfModalWindow: IVideoCategoriesContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: VideoCategoriesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IVideoCategoriesContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: VideoCategoriesActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TVideoCategoriesAction =
	| ISetVideoCategories
	| IChangeSearchString
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
